import { connectedStore } from '../../store';
import getBlockConstraint from '../selectors/block-constraint';
import getLiveDocument from '../../view/accessors/get-live-document';

const getElementsToBeReplaced = (blockId) => {
  if (!blockId) return [];

  const store = connectedStore.get();
  const state = store.getState();
  const blockConstraint = getBlockConstraint(state, blockId);
  const { replaceable, element } = blockConstraint;

  if (!replaceable) return [];

  const document = getLiveDocument();
  const redundantElements = document.querySelectorAll(element);

  // Clean duplicates in cases when provided element selector catch same block twice
  return Array.from(new Set(redundantElements));
};

export default getElementsToBeReplaced;
